@if (reviewData()) {
  <div class="review">
    <h4>Review</h4>
    @if (isIneligible()) {
      <div class="notice-container">
        <lib-notice
          [config]="{
            icon: 'fa-graduation-cap',
            title: 'Not Eligible',
            message:
              'You’re currently ineligible for this program based on your responses. Please review your actions to ensure all information is correct.',
          }">
        </lib-notice>
      </div>
    }
    @else {
      @if (!isAdmin()) {
        <div class="review-message">
          Please verify the information you provided for below. If there is an error, click “Edit” to update the
          information.
        </div>
      }

      @if (showBanner()) {
        <div class="banner">
          <i class="fa-regular fa-triangle-exclamation"></i>
          An Example is provided below of what the Review Prompt Component could look like. Actual Data is not Present.
           
          <i class="fa-solid fa-x font-bold" tabindex="0" role="button" aria-label="Close banner" (click)="showBanner.set(false)" (keydown.enter)="showBanner.set(false)" (keydown.space)="showBanner.set(false)"></i>
        </div>
      }

      @for (prompt of reviewData().prompts | orderBy: 'order'; track $index) {
        <div class="review-container">
          <div class="title">
            {{prompt.title}}
          </div>
          <div class="content">
            <div class="prompt-header">
              <p>{{prompt.header}}</p>
              @if (!enrollmentBuilderView()) {
                 
                <i class="fa-regular fa-pen-to-square" tabindex="0" role="button" aria-label="Edit section" (click)="editSection(reviewData().sessionId, prompt.token)" (keydown.enter)="editSection(reviewData().sessionId, prompt.token)" (keydown.space)="editSection(reviewData().sessionId, prompt.token)"></i>
              }
            </div>
            @for (component of prompt.components | orderBy: 'order'; track $index) {
              <div class="component">
                @if (component.header) {
                  <p class="header">{{component.header}}</p>
                }
                @if (hasNoResponse(component)) {
                  <p class="no-response" data-qa="review-no-response">No response provided</p>
                } @else {
                  @for (input of visibleInputs(component) | orderBy: 'order'; track $index) {
                    <p class="label">
                      @if (input.label && input.label !== 'Yes' && input.label !== 'No' && input.label !== discriminatorLabel) {
                        <span>{{ input.label }}: </span>
                      }
                      @if (input.options.length > 0) {
                        <span class="options">{{ (input.options | filterValueArray: 'true').join(', ') }}</span>
                      } @else if (isSsnInput(input)) {
                        <!-- No titlecase: it would lower-case the mask into "Xxx-xx-1234". -->
                        <span class="options" data-qa="review-masked-ssn">{{ maskSsn(input.value) }}</span>
                      } @else if (isFileInput(input)) {
                        <span class="options" data-qa="review-file-names">{{ input.value }}</span>
                      } @else {
                        <span class="options">{{ formatReviewValue(input) | titlecase }}</span>
                      }
                    </p>
                  }
                }
              </div>
            }
          </div>
        </div>
      } @empty {
        <!-- Without this an unloaded review is indistinguishable from a working one, which is what
             made the blank review step so hard to spot. -->
        @if (!enrollmentBuilderView()) {
          <div class="review-message" data-qa="review-empty">
            We could not load your responses for review. Please go back and try again.
          </div>
        }
      }
    }
  </div>
}
